<template>
  <v-container class="agents" fluid>
    <v-row>
      <v-col cols="auto" class="mr-auto ml-7">
        <h1>{{ $route.meta.title }}</h1>
      </v-col>
      <v-col cols="auto" class="mr-7">
        <v-btn
          v-if="$canRoute('NewAgent')"
          color="primary"
          class="text-none mr-2"
          dark
          outlined
          right
          to="/agents/new"
        >
          Новый агент
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table
          class="table"
          :headers="headers"
          :items="agents"
          disable-sort
          :items-per-page="15"
        >
          <template v-slot:item.actions="{ item }">
            <v-row justify="center" class="flex-nowrap">
              <v-btn
                v-if="$canRoute('EditAgent')"
                icon
                text
                tile
                small
                class="btn__icon pa-0 mr-1"
                width="18"
                height="18"
                :to="`/agents/edit/${item.id}`"
              >
                <v-icon size="large">mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn
                v-if="$can('destroy_agent')"
                icon
                text
                tile
                small
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click.stop="$set(dialog, item.id, true)"
              >
                <v-icon size="large">mdi-close</v-icon>
              </v-btn>

              <v-dialog
                v-model="dialog[item.id]"
                persistent
                :retain-focus="false"
                max-width="350"
              >
                <v-card>
                  <v-card-title class="headline">Удалить организацию?</v-card-title>
                  <v-card-text>Подтверждая, вы удалите организацию.</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary darken-1"
                      text
                      @click="$set(dialog, item.id, false)"
                    >
                      Отменить
                    </v-btn>
                    <v-btn
                      color="primary darken-1"
                      :loading="loading"
                      text
                      @click.prevent='removeAgent(item.id)'
                    >
                      Удалить
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                transition="dialog-top-transition"
                v-model="dialogWarning[item.id]"
                :retain-focus="false"
                max-width="420"
              >
                <v-card>
                  <v-card-title class="headline">Не удалость удалить агента.</v-card-title>
                  <v-card-text>{{ updateResult.message }}</v-card-text>
                  <v-card-text class="pb-2"> Кол-во домофонов: {{ updateResult.doorphones_count }}</v-card-text>
                  <v-card-text class="pb-2"> Кол-во абонентов: {{ updateResult.abonents_count }}</v-card-text>
                  <v-card-text class="pb-2"> Кол-во ключей: {{ updateResult.keys_count }}</v-card-text>
                  <v-card-text class="pb-2"> Кол-во устройств: {{ updateResult.devices_count }}</v-card-text>
                  <v-card-text> Кол-во менеджеров: {{ updateResult.managers_count }}</v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Agents',
  data () {
    return {
      dialog: {},
      dialogWarning: {},
      loading: false,
      updateResult: [],
      headers: [
        {
          text: 'id',
          value: 'id',
        },
        {
          text: 'Организация',
          value: 'user.name',
        },
        {
          text: 'Юридический адрес',
          value: 'legal_address',
        },
        {
          text: 'Фактический адрес',
          value: 'actual_address',
        },
        {
          text: 'Контактное лицо',
          value: 'contact',
        },
        {
          text: 'Диспетчерская',
          value: 'dispatcher_phone',
        },
        {
          text: 'Телефон',
          value: 'telephone',
        },
        {
          text: 'Руководитель',
          value: 'supervisor',
        },
        {
          text: 'Email',
          value: 'user.email',
        },
        {
          text: '',
          value: 'actions',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      agents: 'Agents/agents',
    }),
  },
  methods: {
    ...mapActions({
      loadAllAgents: 'Agents/loadAllAgents',
      deleteAgent: 'Agents/deleteAgent',
    }),
    removeAgent (id) {
      this.loading = true;
      this.deleteAgent(id)
        .then(() => {
          this.$flash_success('Агент успешно удален');
          this.cancelDialogAgent(id);
        })
        .catch((err) => {
          this.$flash_danger('Не удалость удалить агента');
          this.updateResult = err.response.data;
          this.cancelDialogAgent(id);
          this.dialogWarning[id] = true;
        });
    },
    cancelDialogAgent (id) {
      this.dialog[id] = false;
      this.loading = false;
    },
  },
  created () {
    // this.loadAllAgents();
  },
};
</script>

<style lang="scss" scoped>
.v-card__text, .v-card__title {
  word-break: normal; /* maybe !important  */
}
</style>
